// Convert an IContentInfo's content type to a DataQualityDetailProps asset type.
import { SiteUrls } from '@tableau/shared-urls';
import { ExplorableItemType } from '../../../../ts/models/ContentType';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import * as _ from 'underscore';
import {
  DataQualityAssetType,
  DataQualityDetailProps,
  EmbeddableDataQualityStatusChip,
  FeatureFlagsProvider
} from '@tableau/data-catalog-client-components';
import { dataQualityOwnerToTableauUser } from '../../../../ts/models/IDataQualityIndicatorInfo';
import { L10n } from '../../../../ts/L10n/L10n';
import { dataQualityIndicatorInfosToProps, stringToDataQualityType } from '../../../quality/DataQualityType';
import { catalogFeatureFlagsAdapter } from '../../../../catalog/CatalogFeatureFlagsAdapter';

function contentTypeToAssetType(contentType: ExplorableItemType): DataQualityAssetType | null {
  switch (contentType) {
    case 'datasource':
      return 'PublishedDatasource';
    case 'flow':
      return 'Flow';
    case 'dataconnection':
      return 'WebDataConnector';
    case 'database':
      return 'DatabaseServer';
    case 'table':
      return 'DatabaseTable';
    default:
      return null;
  }
}

// Create an appropriate URL for a particular content type.
function urlForContentType(siteUrls: SiteUrls, contentType: ExplorableItemType, id: string):
    string | null {
  switch (contentType) {
    case 'datasource':
      return siteUrls.datasourceUrl(id);
    case 'flow':
      return siteUrls.flowUrl(id);
    case 'database':
      return siteUrls.catalogDatabaseUrl(id);
    case 'table':
      return siteUrls.catalogTableUrl(id);
    default:
      return null;
  }
}

export function DataQualityIndicatorCell(siteUrls: SiteUrls, hasDataQualityIndicator: (row: DataGrid.Row) => boolean):
    React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    render() {
      if (!hasDataQualityIndicator(this.props.row)) {
        return null;
      }

      const contentTypeWithDQW = this.props.row.data as IContentInfo;

      const details = dataQualityIndicatorInfosToProps(
        {
          assetUrl: urlForContentType(siteUrls, contentTypeWithDQW.contentType, contentTypeWithDQW.id),
          assetName: contentTypeWithDQW.name,
          assetType: contentTypeToAssetType(contentTypeWithDQW.contentType),
          onContentItem: true
          },
          contentTypeWithDQW.dataQualityIndicators
        );

      return (
          <span className="tb-quality-indicator-cell">
            <FeatureFlagsProvider featureFlags={catalogFeatureFlagsAdapter()}>
              <EmbeddableDataQualityStatusChip details={details} iconOnly={true} iconOnlyTabIndex={-1} siteUrls={siteUrls} />
            </FeatureFlagsProvider>
          </span>
      );
    }
  });
}
